import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheCalmSanctuary from "./sections/TheCalmSanctuary";
import OnsVerhaal from "./sections/OnsVerhaal";
import TrackTheTruck from "./sections/TrackTheTruck";
import TheMission from "./sections/TheMission";
import OperationalExcellence from "./sections/OperationalExcellence";
import LaCarteDuMoment from "./sections/LaCarteDuMoment";
import ReachOutToOurTeam from "./sections/ReachOutToOurTeam";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheCalmSanctuary />
      <OnsVerhaal />
      <TrackTheTruck />
      <TheMission />
      <OperationalExcellence />
      <LaCarteDuMoment />
      <ReachOutToOurTeam />
      <Footer />
    </div>;
}